import React from 'react';
import reactDom from '../../../../common/react/dom/index';
import Edit from '../../../../components/frontend/account/edit';

export default function init() {
	reactDom(<Edit />, 'js-react-edit');
}
